import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";

const TIPI = ["TUTTE", "RD", "RCA", "TRASPORTATO", "PEDONE", "CICLISTA", "ANIMALE", "ANOMALIA STRADA", "ALTRO"];

export default function SalvaDinamicaDialog({ open, onOpenChange, testo, tipo, onSaved }) {
  const [text, setText] = useState("");
  const [tipi, setTipi] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setText(testo || "");
      setTipi(tipo && TIPI.includes(tipo) ? [tipo] : []);
    }
  }, [open, testo, tipo]);

  const toggle = (t) => setTipi((cur) => {
    if (t === "TUTTE") return cur.includes("TUTTE") ? [] : ["TUTTE"];
    return cur.includes(t) ? cur.filter((x) => x !== t) : [...cur.filter((x) => x !== "TUTTE"), t];
  });

  const save = async () => {
    if (!text.trim()) { toast.error("Inserisci il testo della dinamica"); return; }
    if (!tipi.length) { toast.error("Seleziona almeno una tipologia"); return; }
    setSaving(true);
    try {
      await api.post("/studio/dinamiche-list", { testo: text.trim(), tipi });
      toast.success("Dinamica salvata: disponibile per le pratiche future");
      onSaved && onSaved();
      onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-lg" data-testid="salva-dinamica-dialog">
        <DialogHeader><DialogTitle className="font-head">Salva dinamica</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-slate-300">Descrizione dinamica</Label>
            <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={4} data-testid="salva-din-text" className="mt-1.5 bg-slate-900/60 border-slate-700" placeholder="Descrivi la dinamica del sinistro…" />
          </div>
          <div>
            <Label className="text-slate-300 mb-2 block">Tipologia sinistro associata</Label>
            <div className="flex flex-wrap gap-1.5">
              {TIPI.map((t) => (
                <button key={t} type="button" onClick={() => toggle(t)} data-testid={`salva-din-tipo-${t}`}
                  className={`text-xs font-semibold rounded-md border px-2.5 py-1.5 transition-colors ${tipi.includes(t) ? "border-amber-500 text-amber-400 bg-amber-500/10" : "border-slate-700 text-slate-300 hover:bg-slate-800/50"}`}>
                  {t}
                </button>
              ))}
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="salva-din-cancel" className="border-slate-700 text-slate-200 hover:bg-slate-800">Annulla</Button>
            <Button type="button" onClick={save} disabled={saving} data-testid="salva-din-save" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {saving ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Save className="h-4 w-4 mr-1" />} Salva
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
